import api from '../_api'
import { service as hyperCommonService } from '@/api/hyper-common'
import { service as billingPrimaryService } from '@/api/billing-primary'
import {
    FETCH_AVAILABLE_INVOICE_REQUEST,
    FETCH_AVAILABLE_INVOICE_SUCCESS,
    FETCH_AVAILABLE_INVOICE_FAILED,
    DOWNLOAD_SIMPLE_EXCEL_REQUEST,
    DOWNLOAD_SIMPLE_EXCEL_SUCCESS,
    DOWNLOAD_SIMPLE_EXCEL_FAILED,
    DOWNLOAD_DETAIL_CSV_REQUEST,
    DOWNLOAD_DETAIL_CSV_SUCCESS,
    DOWNLOAD_DETAIL_CSV_FAILED,
    DOWNLOAD_INVOICE_PDF_REQUEST,
    DOWNLOAD_INVOICE_PDF_SUCCESS,
    DOWNLOAD_INVOICE_PDF_FAILED,
    FETCH_INVOICE_MONTHS_REQUEST,
    FETCH_INVOICE_MONTHS_SUCCESS,
    FETCH_INVOICE_MONTHS_FAILED,
    FETCH_SUMMARY_STATISTICS_REQUEST,
    FETCH_SUMMARY_STATISTICS_SUCCESS,
    FETCH_SUMMARY_STATISTICS_FAILED,
    FETCH_SUMMARY_MONTHS_REQUEST,
    FETCH_SUMMARY_MONTHS_SUCCESS,
    FETCH_SUMMARY_MONTHS_FAILED,
    FETCH_SUMMARY_REGIONS_REQUEST,
    FETCH_SUMMARY_REGIONS_SUCCESS,
    FETCH_SUMMARY_REGIONS_FAILED,
    FETCH_SUMMARY_WEEKS_REQUEST,
    FETCH_SUMMARY_WEEKS_SUCCESS,
    FETCH_SUMMARY_WEEKS_FAILED,
    FETCH_SUMMARY_DATES_REQUEST,
    FETCH_SUMMARY_DATES_SUCCESS,
    FETCH_SUMMARY_DATES_FAILED,
    FETCH_SUMMARY_PRODUCTS_REQUEST,
    FETCH_SUMMARY_PRODUCTS_SUCCESS,
    FETCH_SUMMARY_PRODUCTS_FAILED,
    FETCH_SUMMARY_COMPARE_ESTIMATED_REQUEST,
    FETCH_SUMMARY_COMPARE_ESTIMATED_SUCCESS,
    FETCH_SUMMARY_COMPARE_ESTIMATED_FAILED,
    FETCH_SUMMARY_COMPARE_PREV_MONTH_REQUEST,
    FETCH_SUMMARY_COMPARE_PREV_MONTH_SUCCESS,
    FETCH_SUMMARY_COMPARE_PREV_MONTH_FAILED,
    FETCH_TOTAL_COST_REQUEST,
    FETCH_TOTAL_COST_SUCCESS,
    FETCH_TOTAL_COST_FAILED,
    FETCH_SUMMARY_DETAIL_REQUEST,
    FETCH_SUMMARY_DETAIL_SUCCESS,
    FETCH_SUMMARY_DETAIL_FAILED,
    FETCH_COST_BY_MONTH_REQUEST,
    FETCH_COST_BY_MONTH_SUCCESS,
    FETCH_COST_BY_MONTH_FAILED,
    FETCH_CUSTOM_DASHBOARD_REQUEST,
    FETCH_CUSTOM_DASHBOARD_SUCCESS,
    FETCH_CUSTOM_DASHBOARD_FAILED,
    SAVE_CUSTOM_DASHBOARD_REQUEST,
    SAVE_CUSTOM_DASHBOARD_SUCCESS,
    SAVE_CUSTOM_DASHBOARD_FAILED,
    RESET_CUSTOM_DASHBOARD_REQUEST,
    RESET_CUSTOM_DASHBOARD_SUCCESS,
    RESET_CUSTOM_DASHBOARD_FAILED
} from './mutation-type'

/** common */
const getAvailableInvoice = async ({ commit, state, getters, rootGetters }, { usageAccountId, month }) => {
    commit(FETCH_AVAILABLE_INVOICE_REQUEST)
    try {
        const { data } = await billingPrimaryService.getAvailableInvoice({ usageAccountId, month }, rootGetters.requiredService)
        commit(FETCH_AVAILABLE_INVOICE_SUCCESS, data)
        return data
    } catch (error) {
        commit(FETCH_AVAILABLE_INVOICE_FAILED, error)
        throw error
    }
}

const downloadSimpleExcel = async ({ commit, state, getters, rootGetters }, { usageAccountId, month }) => {
    commit(DOWNLOAD_SIMPLE_EXCEL_REQUEST)
    try {
        const { data } = await billingPrimaryService.simpleExcel({ usageAccountId, month }, rootGetters.requiredService)
        commit(DOWNLOAD_SIMPLE_EXCEL_SUCCESS, data)
        return data
    } catch (error) {
        commit(DOWNLOAD_SIMPLE_EXCEL_FAILED, error)
        throw error
    }
}

const downloadDetailCSV = async ({ commit, state, getters, rootGetters }, { usageAccountId, month }) => {
    commit(DOWNLOAD_DETAIL_CSV_REQUEST)
    try {
        const { data } = await billingPrimaryService.detailCSV({ usageAccountId, month }, rootGetters.requiredService)
        commit(DOWNLOAD_DETAIL_CSV_SUCCESS, data)
        return data
    } catch (error) {
        commit(DOWNLOAD_DETAIL_CSV_FAILED, error)
        throw error
    }
}

const downloadInvoicePDF = async ({ commit, state, getters, rootGetters }, { usageAccountId, month, locale }) => {
    commit(DOWNLOAD_INVOICE_PDF_REQUEST)
    try {
        const { data } = await billingPrimaryService.invoicePDF({ usageAccountId, month, locale }, rootGetters.requiredService)
        commit(DOWNLOAD_INVOICE_PDF_SUCCESS, data)
        return data
    } catch (error) {
        commit(DOWNLOAD_INVOICE_PDF_FAILED, error)
        // throw error
    }
}
/** summary */
const getInvoiceMonths = async ({ commit, state, getters, rootGetters }, { usageAccountId, month }) => {
    commit(FETCH_INVOICE_MONTHS_REQUEST)
    try {
        const { data } = await api.fetchInvoiceMonths({ usageAccountId, month }, rootGetters.requiredService)
        commit(FETCH_INVOICE_MONTHS_SUCCESS, data)
        return data
    } catch (error) {
        commit(FETCH_INVOICE_MONTHS_FAILED)
        throw error
    }
}

const getSummaryStatistics = async ({ commit, state, getters, rootGetters }, params) => {
    commit(FETCH_SUMMARY_STATISTICS_REQUEST)
    try {
        const { data, status } = await api.fetchSummaryStatistics(params, rootGetters.requiredService)
        commit(FETCH_SUMMARY_STATISTICS_SUCCESS, { data, status, params })
        return data
    } catch (error) {
        commit(FETCH_SUMMARY_STATISTICS_FAILED, { error, params })
        throw error
    }
}

const getSummaryMonths = async ({ commit, state, getters, rootGetters }, params) => {
    commit(FETCH_SUMMARY_MONTHS_REQUEST)
    try {
        const { data, status } = await api.fetchSummarymonths(params, rootGetters.requiredService)
        commit(FETCH_SUMMARY_MONTHS_SUCCESS, { data, status, params })
        return data
    } catch (error) {
        commit(FETCH_SUMMARY_MONTHS_FAILED, { error, params })
        throw error
    }
}

const getSummaryRegions = async ({ commit, state, getters, rootGetters }, params) => {
    commit(FETCH_SUMMARY_REGIONS_REQUEST)
    try {
        const { data, status } = await api.fetchSummaryRegions(params, rootGetters.requiredService)
        commit(FETCH_SUMMARY_REGIONS_SUCCESS, { data, status, params })
        return data
    } catch (error) {
        commit(FETCH_SUMMARY_REGIONS_FAILED, { error, params })
        throw error
    }
}

const getSummaryWeeks = async ({ commit, state, getters, rootGetters }, params) => {
    commit(FETCH_SUMMARY_WEEKS_REQUEST)
    try {
        const { data, status } = await api.fetchSummaryWeeks(params, rootGetters.requiredService)
        commit(FETCH_SUMMARY_WEEKS_SUCCESS, { data, status, params })
        return data
    } catch (error) {
        commit(FETCH_SUMMARY_WEEKS_FAILED, { error, params })
        throw error
    }
}

const getSummaryDates = async ({ commit, state, getters, rootGetters }, params) => {
    commit(FETCH_SUMMARY_DATES_REQUEST)
    try {
        const { data, status } = await api.fetchSummaryDates(params, rootGetters.requiredService)
        commit(FETCH_SUMMARY_DATES_SUCCESS, { data, status, params })
        return data
    } catch (error) {
        commit(FETCH_SUMMARY_DATES_FAILED, { error, params })
        throw error
    }
}

const getSummaryProducts = async ({ commit, state, getters, rootGetters }, params) => {
    commit(FETCH_SUMMARY_PRODUCTS_REQUEST)
    try {
        const { data, status } = await api.fetchSummaryProducts(params, rootGetters.requiredService)
        commit(FETCH_SUMMARY_PRODUCTS_SUCCESS, { data, status, params })
        return data
    } catch (error) {
        commit(FETCH_SUMMARY_PRODUCTS_FAILED, { error, params })
        throw error
    }
}

const getCompareEstimated = async ({ commit, state, getters, rootGetters }, params) => {
    commit(FETCH_SUMMARY_COMPARE_ESTIMATED_REQUEST)
    try {
        const { data } = await api.fetchSummaryCompareEstimated(params, rootGetters.requiredService)
        commit(FETCH_SUMMARY_COMPARE_ESTIMATED_SUCCESS, { data, params })
        return data
    } catch (error) {
        commit(FETCH_SUMMARY_COMPARE_ESTIMATED_FAILED, { error, params })
        throw error
    }
}

const getComparePrevMonth = async ({ commit, state, getters, rootGetters }, params) => {
    commit(FETCH_SUMMARY_COMPARE_PREV_MONTH_REQUEST)
    try {
        const { data } = await api.fetchSummaryComparePrevMonth(params, rootGetters.requiredService)
        commit(FETCH_SUMMARY_COMPARE_PREV_MONTH_SUCCESS, { data, params })
        return data
    } catch (error) {
        commit(FETCH_SUMMARY_COMPARE_PREV_MONTH_FAILED, { error, params })
        throw error
    }
}

const getTotalCost = async ({ commit, state, getters, rootGetters }, params) => {
    commit(FETCH_TOTAL_COST_REQUEST)
    try {
        const isEstimated = params.isEstimated
        delete params.isEstimated
        const fetchTotalCost = isEstimated ? api.fetchSummaryCompareEstimated : api.fetchSummaryComparePrevMonth
        const { data, status } = await fetchTotalCost(params, rootGetters.requiredService)
        commit(FETCH_TOTAL_COST_SUCCESS, { data, status, isEstimated, params })
        return data
    } catch (error) {
        commit(FETCH_TOTAL_COST_FAILED, { error, params })
        throw error
    }
}

const getSummaryDetail = async ({ commit, state, getters, rootGetters }, params) => {
    commit(FETCH_SUMMARY_DETAIL_REQUEST)
    try {
        const { data, status } = await api.fetchSummaryDetail(params, rootGetters.requiredService)
        commit(FETCH_SUMMARY_DETAIL_SUCCESS, { status, data: data.data })
        return data
    } catch (error) {
        commit(FETCH_SUMMARY_DETAIL_FAILED, error)
        throw error
    }
}

const getCostByMonth = async ({ commit, state, getters, rootGetters }, { currentParams, localParams }) => {
    commit(FETCH_COST_BY_MONTH_REQUEST)
    try {
        const { data, status } = await api.fetchCostByMonth(localParams, rootGetters.requiredService)
        commit(FETCH_COST_BY_MONTH_SUCCESS, { status, data: data.data, params: currentParams })
        return data
    } catch (error) {
        commit(FETCH_COST_BY_MONTH_FAILED, { error, params: currentParams })
        throw error
    }
}

const getCustomDashboard = async ({ commit, state, getters, rootGetters }, params) => {
    commit(FETCH_CUSTOM_DASHBOARD_REQUEST)
    try {
        const { data, status } = await hyperCommonService.fetchCustomDashboard(params, rootGetters.requiredService)
        commit(FETCH_CUSTOM_DASHBOARD_SUCCESS, { status, data: data.data })
        return data
    } catch (error) {
        commit(FETCH_CUSTOM_DASHBOARD_FAILED, error)
        throw error
    }
}

const saveCustomDashboard = async ({ commit, state, getters, rootGetters }, params) => {
    commit(SAVE_CUSTOM_DASHBOARD_REQUEST)
    try {
        const { data, status } = await hyperCommonService.saveCustomDashboard(params, rootGetters.requiredService)
        commit(SAVE_CUSTOM_DASHBOARD_SUCCESS, { status, data: data.data })
        return data
    } catch (error) {
        commit(SAVE_CUSTOM_DASHBOARD_FAILED, error)
        throw error
    }
}

const resetCustomDashboard = async ({ commit, state, getters, rootGetters }, params) => {
    commit(RESET_CUSTOM_DASHBOARD_REQUEST)
    try {
        const { data, status } = await hyperCommonService.resetCustomDashboard(params, rootGetters.requiredService)
        commit(RESET_CUSTOM_DASHBOARD_SUCCESS, { status, data: data.data })
        return data
    } catch (error) {
        commit(RESET_CUSTOM_DASHBOARD_FAILED, error)
        throw error
    }
}

export default {
    getAvailableInvoice,
    downloadSimpleExcel,
    downloadDetailCSV,
    downloadInvoicePDF,
    getInvoiceMonths,
    getSummaryStatistics,
    getSummaryMonths,
    getSummaryRegions,
    getSummaryWeeks,
    getSummaryDates,
    getSummaryProducts,
    getCompareEstimated,
    getComparePrevMonth,
    getTotalCost,
    getSummaryDetail,
    getCostByMonth,
    getCustomDashboard,
    saveCustomDashboard,
    resetCustomDashboard
}
